export default "__VITE_ASSET__02168101__"